import { z } from 'zod';
import { GetQuoteResponseSchema } from './get-quote.ts';

/**
 * validation schema for the response payload
 */
export const PostQuoteResponseSchema = GetQuoteResponseSchema;

export type PostQuoteResponse = z.infer<typeof PostQuoteResponseSchema>;
